// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__R7pFc","label":"styles_label__D-VxD"};